// extracted by mini-css-extract-plugin
module.exports = {"ccart":"cartbox_ccart__2y4Eg","img":"cartbox_img__ap9-2","info":"cartbox_info__G_Fsj","size":"cartbox_size__8Xcn5","btn":"cartbox_btn__a663W"};